module.exports = __webpack_public_path__ + "static/f-JMazariegos-3558e4906f4e7f3f7c957191e4b344b7.jpg";